import React, { useState } from 'react';
import { Send, MessageSquare } from 'lucide-react';
export function ContactForm() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Format message for WhatsApp
    const text = `New enquiry from ${formData.name}%0AEmail: ${formData.email}%0APhone: ${formData.phone}%0AMessage: ${formData.message}`;
    // Open WhatsApp
    window.open(`https://wa.me/447921876472?text=${text}`, '_blank');
  };
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };
  return <section id="contact" className="py-24 bg-gray-50" data-id="element-11">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-12">
        <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-xl overflow-hidden" data-id="element-13">
          <div className="grid grid-cols-1 md:grid-cols-2" data-id="element-14">
            {/* Contact Info Side */}
            <div className="bg-navy-900 p-10 text-white flex flex-col justify-between" data-id="element-15">
              <div data-id="element-16">
                <h3 className="text-2xl font-bold mb-6" data-id="element-17">Get In Touch</h3>
                <p className="text-navy-100 mb-8 leading-relaxed" data-id="element-18">
                  Ready to start your next project? Fill out the form or contact
                  us directly on WhatsApp. We're here to help you succeed.
                </p>

                <div className="space-y-6" data-id="element-19">
                  <div className="flex items-start" data-id="element-20">
                    <MessageSquare className="h-6 w-6 text-whatsapp mt-1 mr-4" data-id="element-21" />
                    <div data-id="element-22">
                      <p className="font-medium text-white" data-id="element-23">WhatsApp Support</p>
                      <p className="text-navy-200" data-id="element-24">+44 7921 876472</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="mt-12" data-id="element-25">
                <div className="w-20 h-1 bg-blue-500 rounded-full mb-6" data-id="element-26"></div>
                <p className="text-sm text-navy-300" data-id="element-27">
                  Tech Vero Solutions
                  <br data-id="element-28" />
                  Excellence in Digital Innovation
                </p>
              </div>
            </div>

            {/* Form Side */}
            <div className="p-10" data-id="element-29">
              <form onSubmit={handleSubmit} className="space-y-6" data-id="element-30">
                <div data-id="element-31">
                  <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-32">
                    Full Name
                  </label>
                  <input type="text" id="name" name="name" required value={formData.name} onChange={handleChange} className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-navy-900 focus:border-transparent outline-none transition-all" placeholder="John Smith" data-id="element-33" />
                </div>

                <div data-id="element-34">
                  <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-35">
                    Email Address
                  </label>
                  <input type="email" id="email" name="email" required value={formData.email} onChange={handleChange} className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-navy-900 focus:border-transparent outline-none transition-all" placeholder="john@company.com" data-id="element-36" />
                </div>

                <div data-id="element-37">
                  <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-38">
                    Phone Number
                  </label>
                  <input type="tel" id="phone" name="phone" required value={formData.phone} onChange={handleChange} className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-navy-900 focus:border-transparent outline-none transition-all" placeholder="+44 7700 900000" data-id="element-39" />
                </div>

                <div data-id="element-40">
                  <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-41">
                    Message
                  </label>
                  <textarea id="message" name="message" rows={4} required value={formData.message} onChange={handleChange} className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-navy-900 focus:border-transparent outline-none transition-all resize-none" placeholder="Tell us about your project..." data-id="element-42"></textarea>
                </div>

                <button type="submit" className="w-full bg-navy-900 text-white font-semibold py-4 rounded-lg hover:bg-navy-800 transition-colors duration-200 flex items-center justify-center shadow-lg hover:shadow-xl transform hover:-translate-y-0.5" data-id="element-43">
                  Send Message
                  <Send className="ml-2 h-5 w-5" data-id="element-44" />
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>;
}